import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  part: {
    fill: '#cccccc',
    stroke: '#000000',
    strokeWidth: '2',
  },
  selectable: {
    pointerEvents: 'all',
    '& > path': {
      fill: '#ffffff',
      pointerEvents: 'all',
      transition: 'all 0.1s',
      cursor: 'url("/stamp.png") 2 2, pointer',
    },
    '& > image': {
      display: 'none',
    },
  },
  hovered: {
    '& > path': {
      fill: 'rgba(192, 198, 75, 0.6)',
    }
  },
  active: {
    '& > path': {
      fill: 'rgba(192, 198, 75, 1)',
    },
    '& > image': {
      display: 'block',
    },
  },
  disabled: {
    pointerEvents: 'all !important',
    cursor: 'not-allowed !important',
    '& > path': {
      fill: '#717171',
    },
    '& > image': {
      display: 'none',
    },
  },
  label: {
    fontFamily: '#827f7f',
    fontSize: '11.5px',
  },
}));
